<template>
  <v-skeleton-loader v-if="isLoadingAsyncData" type="article" />
  <div v-else class="LKPublicationsStorageList">
    <template v-if="errorMessage">
      <div
        class="error--text ml-8"
        v-text="errorMessage"
      />
      <v-btn
        dark
        block
        depressed
        :color="color"
        @click.stop="getData"
        v-text="'Повторить'"
      />
    </template>

    <template v-else>
      <LKPublicationsStorage
        v-for="item in storageListFiltered"
        :key="item.id"
        :data="item"
        :active="active"
        :publication-id="publicationId"
        class="LKPublicationsStorageList__item"
        v-on="$listeners"
      />

      <v-btn
        v-if="storageList.length > 2"
        rounded
        block
        depressed
        color="webflow-color-blue-shadow"
        class="LKPublicationsStorageList__button"
        @click="activeLoadMoreBtn = !activeLoadMoreBtn"
        v-text="loadMoreBtnText"
      />
    </template>
  </div>
</template>

<script>
import LKPublicationsStorage from './LKPublicationsStorage/LKPublicationsStorage.vue'
import PublicationsCardComponentMixin
  from '@/views/LKPublications/components/LKPublicationsCard/PublicationsCardComponentMixin'
import { LkPublicationsApi } from '@/api/resources'


export default {
  name: 'LKPublicationsStorageList',
  components: {
    LKPublicationsStorage,
  },
  mixins: [PublicationsCardComponentMixin],
  data: () => ({
    activeLoadMoreBtn: true,
  }),
  computed: {
    storageList() {
      return this.list?.filter(({ has_user_files: hasUserFiles }) => hasUserFiles) || []
    },
    storageListFiltered() {
      return this.activeLoadMoreBtn ? this.storageList.slice(0, 2) : this.storageList
    },
    loadMoreBtnText() {
      const { length } = this.storageList
      return this.activeLoadMoreBtn
        ? `Показать все (${length})`
        : `Скрыть (${length - 2})`
    },
  },
  methods: {
    async loadData() {
      const api = new LkPublicationsApi()
      const { data } = await api.getStorages(this.publicationId)
      return data
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsStorageList {
  &__item {
    & + & {
      margin-top: 12px;
    }
  }

  &__button {
    margin-top: 16px;
  }
}
</style>
